<template lang="pug">
  .presence-user
    .item {{ shiftTime.username }}
    .item
      .button.yellow(@click="checkin" v-if="!shiftTime.start && user.can_record_shift_times") check in
      .time(v-if="shiftTime.start")
        .button(@click="subtract('start', true)" v-if="!shiftTime.end && user.can_record_shift_times")
          i.fa.fa-angle-down
        .button(@click="add('start', true)" v-if="!shiftTime.end && user.can_record_shift_times")
          i.fa.fa-angle-up
        span {{ shiftTime.start }}
        .button(@click="subtract('start')" v-if="(!shiftTime.end && user.can_record_shift_times) || user.is_board_member")
          i.fa.fa-angle-down
        .button(@click="add('start')" v-if="(!shiftTime.end && user.can_record_shift_times) || user.is_board_member")
          i.fa.fa-angle-up
    .item(v-if="shiftTime.start")
      .button.green(v-if="!shiftTime.end && user.can_record_shift_times" @click="checkout") check out
      .time(v-if="shiftTime.end")
        span {{ shiftTime.end }}
        .button(@click="subtract('end')" v-if="user.can_record_shift_times")
          i.fa.fa-angle-down
        .button(@click="add('end')" v-if="user.can_record_shift_times")
          i.fa.fa-angle-up

</template>

<script>
export default {
  name: 'presence-entry',
  props: ['shiftTime', 'user'],
  data () {
    return {
      loginToken: this.$localStorage.get('loginToken')
    }
  },
  methods: {
    checkin: function () {
      this.$http.put(this.baseURL + 'checkin/')
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.$emit('refresh')
          })
          .catch((err, data) => {
            console.log(err, data)
          })
    },
    checkout: function () {
      this.$http.put(this.baseURL + 'checkout/')
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.$emit('refresh')
          })
          .catch((error) => {
            if (error.response.status === 400) {
              const errorMessage = error.response.body['__all__'][0]
              this.$notify.danger({content: errorMessage})
            } else console.log(error)
          })
    },
    add: function (name, hour) {
      this.$http.put(this.baseURL + 'add-to-' + name + '/' + (hour ? '?hour=true' : ''))
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.$emit('refresh')
          })
          .catch((error) => {
            if (error.response.status === 400) {
              const errorMessage = error.response.body['__all__'][0]
              this.$notify.danger({content: errorMessage})
            } else console.log(error)
          })
    },
    subtract: function (name, hour) {
      this.$http.put(this.baseURL + 'subtract-from-' + name + '/' + (hour ? '?hour=true' : ''))
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.$emit('refresh')
          })
          .catch((err, data) => {
            console.log(err)
          })
    }
  },
  created () {
  },
  computed: {
    baseURL: function () {
      return '/all-shift-times/' + this.shiftTime.id + '/'
    }
  }
}
</script>

<style lang="sass">
.presence-user
  display: grid
  grid-template-columns: [user] 70px [start] 1fr [end] 1fr
  padding-top: 5px
  padding-bottom: 5px
.item
  align-self: center

  span, .button
    margin-right: 3px
  .button
    padding: 0 8px

.time
  display: flex
  align-items: center

.button
  &.yellow
    background-color: #eded90
  &.green
    background-color: rgba(143, 188, 143, 0.58)
</style>



// WEBPACK FOOTER //
// PresenceEntry.vue?42f4621b